<div class="toggle-switch" [ngClass]="state">{{ label }}</div>
